import { Drawer } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { MdArrowForwardIos } from "react-icons/md";
import Button from "shared/components/Button";
import { NAME_SPACES } from "shared/locales/constants";

const View = ({ open, onClose, tracers, onDuplicateToTracer }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const { t: tTracer } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.TRACER);
  const LIST = t("LIST", { returnObjects: true });
  const DRAWER = tTracer("DRAWER", { returnObjects: true });

  return (
    <Drawer
      title={LIST.DUPLICATE_DRAWER.TITLE}
      placement="right"
      onClose={onClose}
      open={open}
      className="offer__drawer"
    >
      <div className="offer__drawer--container">
        {tracers.map((tracer, index) => (
          <div className="offer__card" key={`duplicate-tracer-${index}`}>
            <div className="offer__card--header">
              <h1>{tracer.name}</h1>
              <p>
                {
                  DRAWER.TRACER_DESCRIPTION[
                    get(tracer, "flow.process.theme", "")
                  ]
                }
              </p>
            </div>
            <Button type="primary" onClick={() => onDuplicateToTracer(tracer)}>
              {LIST.DUPLICATE_DRAWER.DUPLICATE}
              <MdArrowForwardIos />
            </Button>
          </div>
        ))}
      </div>
    </Drawer>
  );
};

export default View;
